export const queryKeys = Object.freeze({
  scenariosList: "scenariosList",
  individualScenario: "individualScenario",
  userProfile: "userProfile",
  companyDetails: "companyDetails",
  scenarioDetails: "scenarioDetails",
  mitigation: "mitigation",
  riskOpportunity: "riskOpportunity",
  getStrategyData: "getStrategyData",
  getMarketNewsTrends: "getMarketNewsTrends",
  getMarketTrendsDetails: "getMarketTrendsDetails",
  allSectors: "allSectors",
  industries: "industries",
  articles: "articles",
  industryDetails: "industryDetails",
  appUrls: "appUrls",
  asanaWorkspaces: "asanaWorkspaces",
  asanaProjects: "asanaProjects",
  connectQuickbooks: "connectQuickbooks",
  connectFreshBooks: "connectFreshBooks",
  freshBooksBusiness: "freshBooksBusiness",
});

export const statuses = [
  {
    value: "DRAFT",
    label: "Draft",
    color: "grey",
  },
  {
    value: "IN_PROGRESS",
    label: "In Progress",
    color: "blue",
  },
  {
    value: "READY_FOR_SUBMISSION",
    label: "Ready for Submission",
    color: "purple",
  },
  {
    value: "APPROVED",
    label: "Approved",
    color: "magenta",
  },
  {
    value: "REJECTED",
    label: "Rejected",
    color: "red",
  },
  {
    value: "AI_PENDING",
    label: "Pending",
    color: "orange",
  },
  {
    value: "AI_COMPLETED",
    label: "Completed",
    color: "green",
  },
  {
    value: "AI_FAILED",
    label: "Failed",
    color: "#FF0000",
  },
];

export const createObjectiveStatuses = [
  {
    value: "DRAFT",
    label: "Draft",
    color: "grey",
  },
  {
    value: "READY_FOR_SUBMISSION",
    label: "Ready for Submission",
    color: "purple",
  },
];

export const priorityLevels = [
  {
    value: "LOW",
    label: "Low",
  },
  {
    value: "MEDIUM",
    label: "Medium",
  },
  {
    value: "HIGH",
    label: "High",
  },
  {
    value: "CRITICAL",
    label: "Critical",
  },
];

export const scenarioTypes = [
  {
    value: "ENVIRONMENTAL",
    label: "Environmental",
  },
  {
    value: "BUSINESS",
    label: "Business",
  },
  {
    value: "ECONOMIC",
    label: "Economic",
  },
  {
    value: "TECHNOLOGICAL",
    label: "Technological",
  },
  {
    value: "POLITICAL",
    label: "Political",
  },
  {
    value: "LEGAL",
    label: "Legal",
  },
  {
    value: "HEALTH",
    label: "Health",
  },
  {
    value: "CULTURAL",
    label: "Cultural",
  },
  {
    value: "FINANCIAL",
    label: "Financial",
  },
];

export const businessModels = [
  {
    value: "B2B",
    label: "B2B",
  },
  {
    value: "B2C",
    label: "B2C",
  },
  {
    value: "SUBSCRIPTION",
    label: "Subscription",
  },
  {
    value: "SAAS",
    label: "SaaS",
  },
  {
    value: "MARKETPLACE",
    label: "Marketplace",
  },
];

export const employeeRanges = [
  {
    value: "1-10",
    label: "1-10",
  },
  {
    value: "11-50",
    label: "11-50",
  },
  {
    value: "51-100",
    label: "51-100",
  },
  {
    value: "101-500",
    label: "101-500",
  },
  {
    value: "500+",
    label: "500+",
  },
];

export const industries = [
  { label: "Basic Materials", value: "basic-materials" },
  { label: "Communication Services", value: "communication-services" },
  { label: "Consumer Cyclical", value: "consumer-cyclical" },
  { label: "Consumer Defensive", value: "consumer-defensive" },
  { label: "Energy", value: "energy" },
  { label: "Financial Services", value: "financial-services" },
  { label: "HealthCare", value: "healthcare" },
  { label: "Real Estate", value: "real-estate" },
  { label: "Technology", value: "technology" },
  { label: "Utilities", value: "utilities" },
];

export const marketPosition = [
  {
    value: "LEADER",
    label: "Leader",
  },
  {
    value: "CHALLENGER",
    label: "Challenger",
  },
  {
    value: "NICHE",
    label: "Follower niche",
  },
];
export const financialHealth = [
  {
    value: "GROWTH",
    label: "Growth",
  },
  {
    value: "FLAT",
    label: "Flat",
  },
  {
    value: "DECLINE",
    label: "Decline",
  },
  {
    value: "PLATEAU",
    label: "Plateau",
  },
];

export const revenueBrackets = [
  {
    value: "0-1M",
    label: "0-1M",
  },
  {
    value: "1-5M",
    label: "1-5M",
  },
  {
    value: "6-10M",
    label: "6-10M",
  },
  {
    value: "10-50M",
    label: "10-50M",
  },
  {
    value: "51-100M",
    label: "51-100M",
  },
  {
    value: "100M+",
    label: "100M+",
  },
];

export const legalStructures = [
  {
    value: "SOLE_PROPRIETORSHIP",
    label: "Sole Proprietorship",
  },
  {
    value: "PARTNERSHIP",
    label: "Partnership",
  },
  {
    value: "LLC",
    label: "LLC",
  },
  {
    value: "C_CORPORATION",
    label: "C-Corporation",
  },
  {
    value: "S_CORPORATION",
    label: "S-Corporation",
  },
];

export const ipoStatus = [
  {
    value: "PRE_IPO",
    label: "Pre-IPO",
  },
  {
    value: "PUBLIC",
    label: "Public",
  },
  {
    value: "PRIVATE",
    label: "Private",
  },
];

export const fundingStages = [
  {
    value: "NO_FUNDING_NEEDED",
    label: "No funding needed",
  },
  {
    value: "SEED",
    label: "Seed",
  },
  {
    value: "SERIES_A",
    label: "Series A",
  },
  {
    value: "SERIES_B",
    label: "Series B",
  },
  {
    value: "SERIES_C",
    label: "Series C",
  },
  {
    value: "SERIES_C+",
    label: "Series C+",
  },
];

export const fundingTypes = [
  {
    value: "N/A",
    label: "N/A",
  },
  {
    value: "PRIVATE_EQUITY",
    label: "Private Equity",
  },
  {
    value: "VENTURE_CAPITAL",
    label: "Venture Capital",
  },
  {
    value: "ANGEL",
    label: "Angel",
  },
  {
    value: "OTHER",
    label: "Other",
  },
];

export const defaultCategoriesRisksOpportunity = [
  "Financial",
  "Operational",
  "Supply Chain",
  "Compliance",
  "Marketing",
  "Customer Relations",
  "Technology",
  "Human Resources",
];

export const defaultTrends = [
  {
    value: "market_status",
    label: "Market Status",
  },
  {
    value: "market_holidays",
    label: "Market Holidays",
  },
  {
    value: "covid19",
    label: "COVID-19",
  },
  {
    value: "market_news",
    label: "Market News",
  },
  {
    value: "insider_transactions",
    label: "Insider Transactions",
  },
  {
    value: "insider_ownership",
    label: "Insider Ownership",
  },
  {
    value: "sec_fillings",
    label: "SEC Fillings",
  },
  {
    value: "stock_performance",
    label: "Stock Performance",
  },
  {
    value: "stock_news",
    label: "Stock News",
  },
  {
    value: "stock_chart",
    label: "Stock Chart",
  },
];

export const NewsType = [
  {
    value: "general",
    label: "General",
  },
  {
    value: "forex",
    label: "Forex",
  },
  {
    value: "crypto",
    label: "Crypto",
  },
  {
    value: "merger",
    label: "Merger",
  },
];
